export default "__VITE_ASSET__C2L_BKVv__"